/** Состояние передачи: ждёт очереди, идёт, завершена, упала, отменена пользователем */
export enum EnumTransferState {
  QUEUED = 'queued',
  RUNNING = 'running',
  DONE = 'done',
  FAILED = 'failed',
  CANCELLED = 'cancelled',
}
